import 'typeface-poppins';

class StyleConstants {
  public static readonly TRANSPARENT_COLOR: string = 'transparent';

  public static readonly WHITE_COLOR: string = '#FFFFFF';

  public static readonly DARK_BLUE_COLOR: string = '#26459C';

  public static readonly MEDIUM_BLUE_COLOR: string = '#328BE0';

  public static readonly GREY_COLOR: string = '#575756';

  public static readonly LIGHT_GREY_COLOR: string = '#C0C0C0';

  public static readonly ORANGE_COLOR: string = '#FFB63E';

  public static readonly PINK_COLOR: string = '#E5015B';

  public static readonly LIGHT_GREEN_COLOR: string = '#76BA1B';

  public static readonly HEADER_FONT_SIZE: number = 20;

  public static readonly HEADER_FONT_WEIGHT: number = 400;

  public static readonly HEADER_FONT_FAMILY: string = "'Poppins', cursive";

  public static readonly CARD_TITLE_FONT_SIZE: number = 12;

  public static readonly CARD_TITLE_FONT_WEIGHT: number = 700;

  public static readonly CARD_BODY_FONT_SIZE: number = 12;

  public static readonly CARD_BODY_FONT_WEIGHT: number = 400;

  public static readonly TOOLTIP_TITLE_FONT_SIZE: number = 12;

  public static readonly TOOLTIP_TITLE_FONT_WEIGHT: number = 700;

  public static readonly TOOLTIP_BODY_FONT_SIZE: number = 12;

  public static readonly TOOLTIP_BODY_FONT_WEIGHT: number = 400;

  public static readonly CHART_TICK_FONT_SIZE: number = 12;

  public static readonly PRIMARY_FONT_SIZE: number = 16;

  public static readonly PRIMARY_FONT_WEIGHT: number = 600;

  public static readonly PRIMARY_FONT_FAMILY: string = "'Poppins', sans-serif";

  public static readonly SECONDARY_FONT_SIZE: number = 14;

  public static readonly TERTIARY_FONT_SIZE: number = 12;

  public static readonly PRIMARY_BUTTON_FONT_SIZE: number = 12;

  public static readonly PRIMARY_BUTTON_FONT_WEIGHT: number = 700;

  public static readonly SECONDARY_BUTTON_FONT_SIZE: number = 12;

  public static readonly SECONDARY_BUTTON_FONT_WEIGHT: number = 400;

  public static readonly PRIMARY_BACKGROUND_COLOR: string = '#26459C';

  public static readonly DISABLED_BACKGROUND_COLOR: string = '#E3E3E3';

  public static readonly CALENDAR_HEIGHT: string = '400px';

  public static readonly CALENDAR_WIDTH: string = '350px';

  public static readonly CALENDAR_CELL_HEIGHT: number = 40;

  public static readonly CALENDAR_TILE_BORDER_SIZE: string = '0px';

  public static readonly NAVIGATION_WIDTH: number = 264;

  public static readonly NAVIGATION_COLLAPSED_WIDTH: number = 80;

  public static readonly NAVIGATION_ACCENT_SOFT_COLOR: string = 'rgba(255, 182, 62, 0.16)';

  public static readonly NAVIGATION_ACCENT_TEXT_COLOR: string = '#FFC66B';

  public static readonly NAVIGATION_HOVER_COLOR: string = 'rgba(255, 255, 255, 0.10)';

  public static readonly NAVIGATION_SURFACE_COLOR: string = 'rgba(255, 255, 255, 0.06)';

  public static readonly NAVIGATION_DIVIDER_COLOR: string = 'rgba(255, 255, 255, 0.12)';

  public static readonly NAVIGATION_FAINT_TEXT_COLOR: string = 'rgba(255, 255, 255, 0.38)';
}

export default StyleConstants;
